import { createDI } from '@di/core';

export function createServiceMethodDI<Service, S extends string = string>(
  name: S,
) {
  return createDI<Service, S>(name);
}
